"use client";

import { useQuery } from "@tanstack/react-query";

import { useUserProfile } from "./useAuth";
import { api } from "@/shared/lib/api";

interface RestrictionStatus {
  isRestricted: boolean;
  reason: string | null;
}

/**
 * Статус ограничения текущего пользователя в организации (чёрный список).
 * Бэкенд: GET /organizations/{id}/restriction-status → { isRestricted, reason }.
 * Ограниченный пользователь не может участвовать в турнирах и оставлять отзывы.
 */
export function useOrganizationRestriction(organizationId: string | undefined) {
  const { data: userProfile } = useUserProfile();

  const { data } = useQuery<RestrictionStatus>({
    queryKey: ["organization-restriction", organizationId, userProfile?.id],
    queryFn: async () => {
      const res = await api.get<RestrictionStatus>(
        `/organizations/${encodeURIComponent(String(organizationId))}/restriction-status`,
      );
      return res.data;
    },
    enabled: Boolean(organizationId) && Boolean(userProfile?.id),
    staleTime: 60_000,
  });

  return {
    isRestricted: data?.isRestricted ?? false,
    restrictionReason: data?.reason ?? null,
  };
}
